<template>
    <table class="table mb-0 table-hover">
        <tbody>
            <row :registration-category="registrationCategory" v-for="registrationCategory in registrationCategories"></row>
        </tbody>
    </table>
</template>

<script>
import Row from './Row';

export default {
    name: "TableContainer",
    components: {
        Row,
    },
    props: {
        registrationCategories: {
            type: Array,
            required: true,
            default: () => []
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Assets/components/RegistrationCategories/Tickets/Table/TableContainer.vue